import { type PriceCalculationUnit } from "../api";
import { ValueObject } from "../base";

export class PriceCalculationUnitValue extends ValueObject(
    class {
        readonly value: PriceCalculationUnit | undefined;

        constructor(value: PriceCalculationUnit | undefined) {
            this.value = value;
        }

        public getValue(): PriceCalculationUnit | undefined {
            return this.value;
        }

        public getText(): string {
            switch (this.value) {
                case "CHF":
                    return "CHF";
                case "m²":
                    return "m²";
                case "km":
                    return "km";
                case "m":
                    return "m";
                case "hour":
                    return "Stunden";
                case "day":
                    return "Tage";
                case "minute":
                    return "Minuten";
                case "piece":
                    return "Stück";
                case "scalar":
                    return "";
                case "CHF/m²":
                    return "CHF/m²";
                case "CHF/m":
                    return "CHF/m";
                case "CHF/km":
                    return "CHF/km";
                case "CHF/hour":
                    return "CHF/Stunde";
                case "CHF/day":
                    return "CHF/Tag";
                case "CHF/minute":
                    return "CHF/Minute";
                case "CHF/piece":
                    return "CHF/Stück";
                default:
                    return this.value ?? "";
            }
        }
        public getLabel(): string {
            switch (this.value) {
                case "CHF":
                    return "CHF";
                case "m²":
                    return "m²";
                case "m":
                    return "m";
                case "km":
                    return "km";
                case "hour":
                    return "Stunden";
                case "day":
                    return "Tage";
                case "minute":
                    return "Minuten";
                case "piece":
                    return "Stück";
                case "scalar":
                    return "Faktor";
                case "CHF/m²":
                    return "CHF/m²";
                case "CHF/m":
                    return "CHF/m";
                case "CHF/km":
                    return "CHF/km";
                case "CHF/hour":
                    return "CHF/Stunde";
                case "CHF/day":
                    return "CHF/Tag";
                case "CHF/minute":
                    return "CHF/Minute";
                case "CHF/piece":
                    return "CHF/Stück";
                default:
                    return this.value ?? "keine Einheit";
            }
        }
    }
) {
    static create(unit: PriceCalculationUnit | undefined): PriceCalculationUnitValue {
        return new PriceCalculationUnitValue(unit);
    }
}
